<template>
    <div style="min-height: 100vh; background-color: #f9fafb;">
        <div>
            <nuxt />
        </div>
        <div style="max-width: 1280px; margin: 0 auto; padding: 2rem 1rem;">
            <div style="display: grid; grid-template-columns: 1fr; gap: 2rem;">
                <!-- Formulário de assinatura -->


                <!-- Sidebar com informações da assinatura -->
                <div v-if="$store.getters['isSubscription']" style="background-color: white; border-radius: 0.5rem; box-shadow: 0 4px 6px rgba(0,0,0,0.1); padding: 1.5rem; position: sticky; top: 2rem;">
                    <h3 style="font-size: 1.125rem; font-weight: 600; color: #111827; margin-bottom: 1rem;">Resumo da Assinatura</h3>

                    <!-- Informações da assinatura -->
                    <div style="margin-bottom: 1rem; padding-bottom: 1rem; border-bottom: 1px solid #e5e7eb;">
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
                            <span style="font-size: 0.875rem; color: #6b7280;">Plano:</span>
                            <span style="font-weight: 500; color: #111827;">{{ $store.getters['getSubscriptionTitle'] }}</span>
                        </div>

                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
                            <span style="font-size: 0.875rem; color: #6b7280;">Primeira cobrança:</span>
                            <span style="font-weight: bold; color: #059669; font-size: 1.125rem;">
                                R$ {{ convertCurrency($store.getters['getSubscriptionAmountFirstCharge'] / 100, 'R$ ', 2) }}
                            </span>
                        </div>

                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
                            <span style="font-size: 0.875rem; color: #6b7280;">Próximas cobranças:</span>
                            <span style="font-weight: 500; color: #111827;">
                                R$ {{ convertCurrency($store.getters['getSubscriptionAmount'] / 100, 'R$ ', 2) }}
                            </span>
                        </div>

                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <span style="font-size: 0.875rem; color: #6b7280;">Periodicidade:</span>
                            <span style="font-weight: 500; color: #111827; text-transform: capitalize;">{{ getPeriodicityText($store.getters['getSubscriptionPeriodicity']) }}</span>
                        </div>
                    </div>

                    <div style="background-color: #eff6ff; border: 1px solid #bfdbfe; border-radius: 0.375rem; padding: 1rem;">
                        <h4 style="font-weight: 600; color: #1e40af; margin-bottom: 0.5rem;">Vantagens da Assinatura</h4>
                        <ul style="font-size: 0.875rem; color: #1d4ed8; list-style: none; padding: 0;">
                            <li style="display: flex; align-items: center; margin-bottom: 0.25rem;">
                                <svg style="width: 1rem; height: 1rem; color: #2563eb; margin-right: 0.5rem;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                                Acesso contínuo ao conteúdo
                            </li>
                            <li style="display: flex; align-items: center; margin-bottom: 0.25rem;">
                                <svg style="width: 1rem; height: 1rem; color: #2563eb; margin-right: 0.5rem;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                                Atualizações automáticas
                            </li>
                            <li style="display: flex; align-items: center; margin-bottom: 0.25rem;">
                                <svg style="width: 1rem; height: 1rem; color: #2563eb; margin-right: 0.5rem;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                                Suporte prioritário
                            </li>
                            <li style="display: flex; align-items: center;">
                                <svg style="width: 1rem; height: 1rem; color: #2563eb; margin-right: 0.5rem;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                                Cancele quando quiser
                            </li>
                        </ul>
                    </div>

                    <div style="background-color: #fef3c7; border: 1px solid #fde68a; border-radius: 0.375rem; padding: 1rem; margin-top: 1rem;">
                        <div style="display: flex; align-items: flex-start;">
                            <svg style="width: 1.25rem; height: 1.25rem; color: #d97706; margin-right: 0.5rem; margin-top: 0.125rem;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                            </svg>
                            <div>
                                <h4 style="font-weight: 600; color: #92400e; margin-bottom: 0.25rem;">Importante</h4>
                                <p style="font-size: 0.875rem; color: #b45309;">
                                    Esta é uma assinatura recorrente. Você será cobrado automaticamente
                                    com periodicidade {{ getPeriodicityText($store.getters['getSubscriptionPeriodicity']) }}.
                                    Você pode cancelar a qualquer momento.
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Informações de segurança -->
                    <div style="margin-top: 1.5rem; padding-top: 1.5rem; border-top: 1px solid #e5e7eb;">
                        <div style="display: flex; align-items: center; justify-content: center; gap: 1rem; font-size: 0.875rem; color: #6b7280;">
                            <div style="display: flex; align-items: center;">
                                <svg style="width: 1rem; height: 1rem; color: #10b981; margin-right: 0.25rem;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                                </svg>
                                SSL Seguro
                            </div>
                            <div style="display: flex; align-items: center;">
                                <svg style="width: 1rem; height: 1rem; color: #10b981; margin-right: 0.25rem;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                                Pagamento Seguro
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { convertCurrency } from '~/assets/js/methods'

export default {
    setup() {
        return {
            convertCurrency
        }
    },
    methods: {
        getPeriodicityText(periodicity) {
            const periodicityMap = {
                'monthly': 'Mensal',
                'weekly': 'Semanal',
                'yearly': 'Anual',
                'daily': 'Diário'
            }
            return periodicityMap[periodicity] || 'Mensal'
        }
    }
}
</script>

<style scoped>
/* Estilos específicos para o layout de assinatura */
.subscription-layout {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.sticky-sidebar {
    position: sticky;
    top: 2rem;
}
</style>
